import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.js'
import self from './self.js'
import users from './users.js'
import gardens from './gardens.js'
import comments from './comments.js'
import lovers from './lovers.js'
import contributors from './contributors.js'
import plants from './plants.js'
import activities from './activities.js'
import sharingActivities from './sharingActivities.js'
import categories from './categories.js'
import level from './level.js'
import snackbar from './snackbar'
import fullScreenPicture from './fullScreenPicture'
import install from './install'
import update from './update'
import ideas from './ideas'

const fb = require("../firebase.js");

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    auth,
    self,
    users,
    gardens,
    comments,
    lovers,
    contributors,
    plants,
    activities,
    sharingActivities,
    categories,
    level,
    snackbar,
    fullScreenPicture,
    install,
    update,
    ideas,
  },
})
